import { render, staticRenderFns } from "./DemoGuideMenuSection.vue?vue&type=template&id=017152aa&scoped=true&"
import script from "./DemoGuideMenuSection.vue?vue&type=script&lang=js&"
export * from "./DemoGuideMenuSection.vue?vue&type=script&lang=js&"
import style0 from "./DemoGuideMenuSection.vue?vue&type=style&index=0&id=017152aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017152aa",
  null
  
)

export default component.exports